import Vue from 'vue'
import Router from 'vue-router'
import index from '@/pages/index'
import search from '@/pages/search'
import details from '@/pages/details'
import newdetails from '@/pages/newdetails'
import newdetail from '@/pages/newdetail'
import index1 from '@/pages/index1'
import index2 from '@/pages/index2'
import index3 from '@/pages/index3'
import newindex from '@/pages/newindex'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/search',
      name: 'search',
      component: search
    },
    {
      path: '/details',
      name: 'details',
      component: details
    },
    {
      path: '/newdetails',
      name: 'newdetails',
      component: newdetails,
      meta:{
        title: '基金百科',
        keepAlive: false
      }

    },
    {
      path: '/index1',
      name: 'index1',
      component: index1
    },
    {
      path: '/index2',
      name: 'index2',
      component: index2
    },
    {
      path: '/index3',
      name: 'index3',
      component: index3,
      meta:{
        title: '基金百科',
        keepAlive: false
      }

    },
    {
      path: '/zgyh/newindex',
      name: 'newindex',
      component: newindex,
      meta:{
        title: '基金百科',
        keepAlive: false
      }

    },
    {
      path: '/newdetail',
      name: 'newdetail',
      component: newdetail,
      meta:{
        title: '基金百科',
        keepAlive: false
      }

    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js